export const AgentCoSupportIcon = ({ height = '35', width = '35', className = '' }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="35" height="35" rx="4" fill="#75F3FB" />
      <path
        d="M26.5 17.22C26.5 11.73 22.24 8 17.5 8C12.81 8 8.5 11.65 8.5 17.28C7.9 17.62 7.5 18.26 7.5 19V21C7.5 22.1 8.4 23 9.5 23H10.5V16.9C10.5 13.03 13.63 9.9 17.5 9.9C21.37 9.9 24.5 13.03 24.5 16.9V24H16.5V26H24.5C25.6 26 26.5 25.1 26.5 24V22.78C27.09 22.47 27.5 21.86 27.5 21.14V18.84C27.5 18.14 27.09 17.53 26.5 17.22Z"
        fill="#05050D"
      />
      <path
        d="M14.5 19C15.0523 19 15.5 18.5523 15.5 18C15.5 17.4477 15.0523 17 14.5 17C13.9477 17 13.5 17.4477 13.5 18C13.5 18.5523 13.9477 19 14.5 19Z"
        fill="#05050D"
      />
      <path
        d="M20.5 19C21.0523 19 21.5 18.5523 21.5 18C21.5 17.4477 21.0523 17 20.5 17C19.9477 17 19.5 17.4477 19.5 18C19.5 18.5523 19.9477 19 20.5 19Z"
        fill="#05050D"
      />
      <path
        d="M23.5 16.03C23.2615 14.6241 22.5334 13.348 21.4444 12.4274C20.3555 11.5068 18.9759 11.0012 17.55 11C14.52 11 11.26 13.51 11.52 17.45C12.7533 16.9458 13.8427 16.144 14.6907 15.1162C15.5388 14.0884 16.1191 12.8667 16.38 11.56C17.69 14.19 20.38 16 23.5 16.03Z"
        fill="#05050D"
      />
    </svg>
  );
};
